import axios from 'axios';
import AuthHandler from './AuthHandler';
import { navigate } from './navigation';
import API_BASE_URL from "../config/Api";
const Axios = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

Axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      AuthHandler(error.response.status, null, navigate);
    }
    return Promise.reject(error);
  }
);

export default Axios;
